import auth from '@/router/allRoutes/auth'
import liveView from '@/router/allRoutes/liveView'
import trackVideo from '@/router/allRoutes/trackVideo'
import route from '@/router/allRoutes/route'
import driverScore from '@/router/allRoutes/driverScore'
import notification from '@/router/allRoutes/notification'
import license from '@/router/allRoutes/license'
import report from '@/router/allRoutes/report'
import maintenance from '@/router/allRoutes/maintenance'
import master from '@/router/allRoutes/master'
import setting from '@/router/allRoutes/setting'
import trackingTemp from '@/router/allRoutes/trackingTemp'
import others from '@/router/allRoutes/others'
import deliveryRequest from '@/router/allRoutes/deliveryRequest'
import delivery from '@/router/allRoutes/delivery'
import fleetTask from '@/router/allRoutes/fleetTask'
import controlTower from '@/router/allRoutes/controlTower'
import videoHistory from '@/router/allRoutes/videoHistory'
import costManagement from '@/router/allRoutes/costManagement'
import fleetAvailability from './allRoutes/fleet-availability'
import integration from '@/router/allRoutes/integration'
import landMeasurement from '@/router/allRoutes/land-measurement'
import companyTicket from '@/router/allRoutes/companyTicket'
import deliveryScheduler from '@/router/allRoutes/delivery-scheduler'
import routeOptimization from '@/router/allRoutes/route-optimization'
import marketplace from '@/router/allRoutes/marketplace'
import fleetTaskInstant from '@/router/allRoutes/fleet-task-instant'
import salesOrder from '@/router/allRoutes/sales-order'
import unsubscribe from '@/router/allRoutes/unsubscribe'
import trackvision from '@/router/allRoutes/trackvision'
import chat from '@/router/allRoutes/chat'

import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/dashboard',
    name: 'Dashboard Direct',
    apollo: {},
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(to, from, next) {
        if (store.state.identity.whoami === null) {
          next({ name: 'Login' })
        } else {
          Helper.methods.userLogging('Access', to)
          if (
            store.getters['identity/hasAccess']([
              'a1a-dasbor-statuskendaraan:read',
              'a1b-dasbor-jarak&totalmengemudi:read',
              'a1c-dasbor-durasi&totalmengemudi:read',
              'a1d-dasbor-bahanbakar:read',
              'a1e-dasbor-skorpengemudi:read',
              'a1f-dasbor-kendaraangeolokasi:read',
            ])
          ) {
            next()
          } else {
            next({ name: '404' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/router/views/dashboards/index'),
  },
  {
    path: '/',
    name: 'Dashboard',
    apollo: {},
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, from, next) {
        if (store.state.identity.whoami === null) {
          next({ name: 'Login' })
        } else if (
          store.getters['identity/hasAccessAll']([
            'alert_rule_template:read',
            'alert_rule_template:create',
          ]) &&
          !store.state.identity.whoami?.onboardingNotifData?.setupNotifCompleted &&
          store.state.identity.whoami?.onboardingNotifData?.onboardingNotif
        ) {
          next({ name: 'Onboarding' })
        } else {
          Helper.methods.userLogging('Access', _)
          const ctHomepageCompanies = JSON.parse(
            store.state.identity.featureFlag.find((feature) => feature.key == 'onboardingCT')
              .value || []
          )
          const userCompanyId = Number(store.state.identity.whoami?.companyId || '')

          const shouldRedirectToCT = ctHomepageCompanies.includes(userCompanyId)

          if (
            shouldRedirectToCT &&
            store.getters['identity/hasAccess'](['h1b-control-tower-v2:read'])
          ) {
            next({ name: 'Control Tower V2' })
          } else if (
            store.getters['identity/hasAccess']([
              'a1a-dasbor-statuskendaraan:read',
              'a1b-dasbor-jarak&totalmengemudi:read',
              'a1c-dasbor-durasi&totalmengemudi:read',
              'a1d-dasbor-bahanbakar:read',
              'a1e-dasbor-skorpengemudi:read',
              'a1f-dasbor-kendaraangeolokasi:read',
            ])
          ) {
            next()
          } else if (
            store.getters['identity/hasAccess']([
              'b1a-default-liveview:read',
              'b1f-liveview-v2:read',
            ])
          ) {
            next({ name: 'Liveview' })
          } else if (
            store.getters['identity/hasAccess']([
              'service_order:read',
              'service_order:update',
              'service_order:create',
              'service_order:delete',
            ])
          ) {
            next({ name: 'Service' })
          } else if (
            store.getters['identity/hasAccessAll'](['tms_driver:read', 'tms_driver:update']) &
            !store.getters['identity/hasAccess'](['vgroups:read'])
          ) {
            next({ name: 'Contact Us' })
          } else {
            next({ name: '404' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/router/views/dashboards/index'),
  },
  {
    path: '/scheduler',
    name: 'Dashboard Scheduler',
    apollo: {},
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, from, next) {
        if (store.state.identity.whoami === null) {
          next({ name: 'Login' })
        } else {
          Helper.methods.userLogging('Access', _)
          if (store.getters['identity/hasAccess'](['dashboard-scheduler:read'])) {
            next()
          } else {
            next({ name: 'Dashboard' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/router/views/dashboards/contents/scheduler'),
  },
  {
    path: '/scheduler/create',
    name: 'Create Dashboard Scheduler',
    apollo: {},
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, from, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['dashboard-scheduler:read'])) {
          next()
        } else {
          next({ name: 'Dashboard' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ '@/router/views/dashboards/contents/scheduler/form'
      ),
  },
  {
    path: '/scheduler/update/:id',
    name: 'Update Dashboard Scheduler',
    apollo: {},
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, from, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['dashboard-scheduler:read'])) {
          next()
        } else {
          next({ name: 'Dashboard' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ '@/router/views/dashboards/contents/scheduler/form'
      ),
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    apollo: {},
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, from, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'alert_rule_template:read',
            'alert_rule_template:create',
          ]) &&
          !store.state.identity.whoami?.onboardingNotifData?.setupNotifCompleted &&
          store.state.identity.whoami?.onboardingNotifData?.onboardingNotif
        ) {
          next()
        } else {
          next({ name: 'Dashboard' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/router/views/onboarding/index'),
  },
  {
    path: '/profile/',
    name: 'Profile',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'd4a-default-mdpengguna:read',
            'd5a-default-mdkaryawan:read',
            'd7a-default-md-route:read',
            'tms:read',
            'vmread',
          ])
        ) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/profile/index'),
  },
  {
    path: '/profile/addemail',
    name: 'Add Email',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'd4a-default-mdpengguna:read',
            'd5a-default-mdkaryawan:read',
            'd7a-default-md-route:read',
            'tms:read',
            'vms:read',
          ])
        ) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/profile/add/email'),
  },
  {
    path: '/profile/addnumber',
    name: 'Add Number',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'd4a-default-mdpengguna:read',
            'd5a-default-mdkaryawan:read',
            'd7a-default-md-route:read',
            'tms:read',
            'vms:read',
          ])
        ) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/profile/add/phoneNo'),
  },
  {
    path: '/profile/changeemail',
    name: 'Change Email',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'd4a-default-mdpengguna:read',
            'd5a-default-mdkaryawan:read',
            'd7a-default-md-route:read',
            'tms:read',
            'vms:read',
          ])
        ) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/profile/update/email'),
  },
  {
    path: '/profile/changenumber',
    name: 'Change Number',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'd4a-default-mdpengguna:read',
            'd5a-default-mdkaryawan:read',
            'd7a-default-md-route:read',
            'tms:read',
            'vms:read',
          ])
        ) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/profile/update/phoneNo'),
  },
  ...auth,
  ...liveView,
  ...controlTower,
  ...trackVideo,
  ...route,
  ...driverScore,
  ...notification,
  ...license,
  ...report,
  ...maintenance,
  ...master,
  ...setting,
  ...trackingTemp,
  ...deliveryRequest,
  ...delivery,
  ...others,
  ...fleetTask,
  ...videoHistory,
  ...costManagement,
  ...integration,
  ...fleetAvailability,
  ...landMeasurement,
  ...companyTicket,
  ...deliveryScheduler,
  ...routeOptimization,
  ...marketplace,
  ...fleetTaskInstant,
  ...salesOrder,
  ...unsubscribe,
  ...trackvision,
  ...chat,
]
